<script lang="ts">
  import { POWER_DEMAND, POWER_MAX_PER_SYSTEM, POWER_SYSTEMS, type PowerSystem } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import { send } from "../net/intents.js";

  const snap = $derived(ship.snap!);
  const p = $derived(snap.power);
  const total = $derived(p.cooling + p.life + p.comms);
  const free = $derived(p.output - total);
  const LABEL: Record<PowerSystem, string> = { cooling: "REACTOR COOLING", life: "LIFE SUPPORT", comms: "INTERCOM BUS" };
  const EFFECT: Record<PowerSystem, string> = { cooling: "drain", life: "O2", comms: "link" };
  function set(system: PowerSystem, value: number) { send("power.set", { system, value: Math.max(0, Math.min(POWER_MAX_PER_SYSTEM, value)) }); }
</script>

<div class="block" aria-labelledby="power-title">
  <h3 id="power-title">POWER DISTRIBUTION — OUTPUT {p.output} / DEMAND {POWER_DEMAND * 3}</h3>
  <p class={free < 0 ? "bad" : "dim"}>{free > 0 ? `${free} UNIT${free === 1 ? "" : "S"} UNALLOCATED` : free === 0 ? "FULLY ALLOCATED. NOTHING IS SPARE." : "OVER BUDGET — LOAD WILL BE SHED"}</p>
  <table>
    <tbody>
      {#each POWER_SYSTEMS as sys}
        {@const v = p[sys]}
        <tr class={v < POWER_DEMAND ? (v <= 1 ? "bad" : "warn") : ""}>
          <th scope="row">{LABEL[sys]}</th>
          <td class="lamps" aria-label="{v} of {POWER_DEMAND}">{"●".repeat(v)}{"○".repeat(POWER_DEMAND - v)}</td>
          <td class="ctl">
            <button onclick={() => set(sys, v - 1)} disabled={v <= 0} aria-label="Less power to {LABEL[sys]}">−</button>
            <button onclick={() => set(sys, v + 1)} disabled={v >= POWER_MAX_PER_SYSTEM || free <= 0} aria-label="More power to {LABEL[sys]}">+</button>
          </td>
          <td class="dim">{v < POWER_DEMAND ? `${EFFECT[sys]} ↓` : "nominal"}</td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<style>
  .block { border: 1px solid var(--fg-dim); padding: 0.7rem; }
  table { border-collapse: collapse; width: 100%; }
  th { text-align: left; font-weight: normal; padding: 0.25rem 0.4rem 0.25rem 0; white-space: nowrap; }
  td { padding: 0.25rem 0.3rem; }
  .lamps { letter-spacing: 0.15em; font-size: 1.1em; }
  .ctl button { min-height: 36px; min-width: 36px; padding: 0 0.6em; }
</style>
